import { render, staticRenderFns } from "./LocationList.vue?vue&type=template&id=33f017b9&scoped=true"
import script from "./LocationList.vue?vue&type=script&lang=ts"
export * from "./LocationList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f017b9",
  null
  
)

export default component.exports